const supportedLocales = ['es', 'pt', 'de', 'fr'];

module.exports = { supportedLocales };
